import React, { Component } from "react";
import ImageStep1 from "../../assets/step-1.png";
import ImageStep2 from "../../assets/step-2.png";
import ImageStep3 from "../../assets/step-3.png";
import ImageStep4 from "../../assets/step-4.png";
import _directDownload from "../../assets/download-icon.png";
import manualFile from "../../assets/pdf/PMG Project Proponent (Private) Manual.pdf";
import { Image } from "react-bootstrap";

class HowItWorks extends Component {
  render() {
    return (
      <div className={`how-it-works-wrapper`} id="how-it-works">
        <div className="container">
          <h2>How it Works</h2>
          <a
            href={manualFile}
            type="application/pdf"
            target="_blank"
            className="pdf-wrapper manual-wrapper"
          >
            <Image src={_directDownload} alt="Issue Resolved" />
            Manual
          </a>
          <div className="list-pdf-wrapper">
            <ul className="how-it-works">
              <li>
                <div className="work-steps">
                  <div className="how-it-works-image">
                    <Image src={ImageStep1} alt="Login or Register" />
                  </div>
                  <h3>Login or Register</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor.
                  </p>
                </div>
              </li>
              <li>
                <div className="work-steps">
                  <div className="how-it-works-image">
                    <Image src={ImageStep2} alt="Create Project & Add Issues" />
                  </div>
                  <h3>Create Project & Add Issue(s)</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor.
                  </p>
                </div>
              </li>
              <li>
                <div className="work-steps">
                  <div className="how-it-works-image">
                    <Image src={ImageStep3} alt="Monitor Issues and status" />
                  </div>
                  <h3>Monitor Issues and status</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor.
                  </p>
                </div>
              </li>
              <li>
                <div className="work-steps">
                  <div className="how-it-works-image">
                    <Image src={ImageStep4} alt="Issue Resolved" />
                  </div>
                  <h3>Issue Resolved</h3>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor.
                  </p>
                </div>
              </li>
            </ul>
            {/* <div className="pdf-box">
              <a
                href={brochureFile}
                type="application/pdf"
                target="_blank"
                className="pdf-wrapper brochure-wrapper"
              >
                <div className="pdf-icon">
                  {brochureIcon ? (
                    <Image src={brochureIcon} alt="Issue Resolved" />
                  ) : (
                    <span>PDF</span>
                  )}
                </div>
                <div className="pdf-name">Project Monitoring Group</div>
              </a>
              <a
                href={manualFile}
                type="application/pdf"
                target="_blank"
                className="pdf-wrapper manual-wrapper"
              >
                <div className="pdf-icon">
                  {manualIcon ? (
                    <Image src={manualIcon} alt="Issue Resolved" />
                  ) : (
                    <span>PDF</span>
                  )}
                </div>
                <div className="pdf-name">
                  Project Monitoring Group
                  <span>Project Proponent (Private)</span>
                </div>
              </a>
            </div>*/}
          </div>
        </div>
      </div>
    );
  }
}

export default HowItWorks;
